import UAParser from 'ua-parser-js'

import { getEnvironmentAtRunTime } from '@cash-web/shared-util-environment'

import { webUrlToLaunchLinkHandler } from './web-url-to-launch-link'

export const ANDROID_STORE =
  'https://play.google.com/store/apps/details?id=com.squareup.cash&referrer=utm_medium%3Dweb%26utm_source%3Dcash-web'
export const APPLE_STORE = 'https://itunes.apple.com/us/app/square-cash/id711923939?pt=302818&mt=8&ct=cash-web'

// exported for testing
export const APP_DOWNLOAD_WITH_DEEP_LINK_PRODUCTION = 'https://click.cash.app/ui6m/b6ca51f0'
const APP_DOWNLOAD_WITH_DEEP_LINK_STAGING = 'https://click.cash.app/LhNg/35a5f3f8'

export const getAppStoreUrl = () => {
  const uaParser = new UAParser()
  const os = uaParser.getOS()
  return os.name === 'Android' ? ANDROID_STORE : APPLE_STORE
}

export const getAppDownloadWithDeepLinkURL = (customUrl?: string) => {
  const env = getEnvironmentAtRunTime()
  const isProd = env === 'production'

  const currentHref = typeof window !== 'undefined' ? window.location.href : ''
  const deepLinkParam = isProd ? currentHref : currentHref.replace(/^https?:\/\//i, 'cashme://')
  const baseUrl = customUrl || (isProd ? APP_DOWNLOAD_WITH_DEEP_LINK_PRODUCTION : APP_DOWNLOAD_WITH_DEEP_LINK_STAGING)

  return `${baseUrl}?deep_link_value=${encodeURIComponent(deepLinkParam)}`
}

const getLaunchLinkUrl = (currentUrl?: URL) => {
  for (const routeAction of webUrlToLaunchLinkHandler) {
    const match = routeAction.match.find(routeRegexMatch => {
      const redirectToParam = currentUrl?.searchParams.get('redirectTo') ?? ''

      const redirectParam = currentUrl?.searchParams.get('redirect') ?? ''
      return (
        routeRegexMatch.test(redirectToParam) ||
        routeRegexMatch.test(decodeURIComponent(redirectParam)) ||
        routeRegexMatch.test(decodeURIComponent(currentUrl?.href ?? ''))
      )
    })

    if (match) {
      return routeAction.generateLaunchLink(currentUrl)
    }
  }
  return undefined
}

export const deeplinkToApp = () => {
  const currentUrl = typeof window !== 'undefined' ? new URL(window.location.href) : undefined
  const launchLink = getLaunchLinkUrl(currentUrl)

  const env = getEnvironmentAtRunTime()
  const isProd = env === 'production'
  const hostname = isProd ? 'cash.app' : 'cashstaging.app'

  if (launchLink) {
    window.location.href = 'cashme://' + hostname + launchLink
  } else {
    // Fallback URL that will just launch the app
    window.location.href = `cashme://${hostname}/launch`
  }
}
